import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchRejectionReason } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";

const RejectionReasonDropDown = ({ onChange, required }) => {
  const {
    data: sampleTypes,
    isLoading,
    error,
  } = useQuery(["Rejection Reason DropDown"], fetchRejectionReason, {
    staleTime: DROPDOWN_STALE_TIME,
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading rejection reasons</div>;

  const options =
    sampleTypes?.data?.data.map((option) => ({
      value: option.id,
      label: option.sample_rejection_reason,
    })) || [];

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      onChange(selectedOption);
    } else {
      onChange(null); // Handle case when cleared
    }
  };

  return (
    <>
      <label className="form-label">
        Rejection Reason <span className="alertColor">*</span>
      </label>
      <Select
        options={options}
        onChange={handleChange}
        isClearable
        placeholder="---Rejection Reason---"
        classNamePrefix="react-select"
        className={`react-select-container ${required ? "is-invalid" : ""}`}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
      {required && <div className="text-danger">This field is required</div>}{" "}
      {/* Optional error message */}
    </>
  );
};

export default RejectionReasonDropDown;
